import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.homework.management.summary;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    LOAD_USERHOMEWORK_STATISTICS_ASYNC: `${uid}.loadUserHomeworkStatisticsAsync`,
    LOAD_USERHOMEWORK_STATISTICS_SUCCESS: `${uid}.loadUserHomeworkStatisticsSuccess`,
    LOAD_USERHOMEWORK_STATISTICS_FAILURE: `${uid}.loadUserHomeworkStatisticsFailure`,
    RETURN_USER_HOMEWORK_ASYNC: `${uid}.returnUserHomeworkAsync`,
    RETURN_USER_HOMEWORK_SUCCESS: `${uid}.returnUserHomeworkSuccess`,
    RETURN_USER_HOMEWORK_FAILURE: `${uid}.returnUserHomeworkFailure`,
    FIX_HOMEWORK_ASYNC: `${uid}.fixHomeworkAsync`,
    FIX_HOMEWORK_SUCCESS: `${uid}.fixHomeworkSuccess`,
    FIX_HOMEWORK_FAILURE: `${uid}.fixHomeworkFailure`,
    FIX_HOMEWORK_ZIP_ASYNC: `${uid}.fixHomeworkZipAsync`,
    FIX_HOMEWORK_ZIP_SUCCESS: `${uid}.fixHomeworkZipSuccess`,
    FIX_HOMEWORK_ZIP_FAILURE: `${uid}.fixHomeworkZipFailure`,
};

export { ActionTypes };
